import Notification from "@sentrei/common/models/Notification";

import {timestamp} from "@sentrei/functions/__mocks__/firebase-testing";

import {profileGet} from "./Profile";

export const notificationChatResponse: Notification.Response = {
  action: "created",
  activityId: "notificationId",
  updatedAt: timestamp,
  type: "chat",
  user: profileGet,
};

export const notificationUpdateResponse: Notification.Response = {
  action: "updated",
  activityId: "notificationId",
  updatedAt: timestamp,
  type: "update",
  user: profileGet,
};
